// src/config.js

export const APP_CONFIG = {
  AI_NAME: "Teta Zeitouna",  // Easily changeable
  AI_EMOJI: "🐪",    // Emoji can also be dynamic
  AI_ROLE: "Arabic Language Tutor",
  // Add other configs here (e.g., theme colors, API endpoints)
};